import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

// builds a local Date from a calendar string. new Date('YYYY-MM-DD') parses as UTC
// midnight and lands on the previous day in any negative-offset timezone.
function parseCalendarDate(isoDate) {
  if (!isoDate) return null;

  const [year, month, day] = String(isoDate).split('-').map(Number);
  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
}

/**
 * formats a plain calendar date coming from the api ("YYYY-MM-DD")
 * @param isoDate - calendar date string, e.g. '2026-07-27'
 */
export function formatCalendarDate(isoDate) {
  const date = parseCalendarDate(isoDate);
  if (!date) return '';
  return dayjs(date).format('MMM D, YYYY');
}

/**
 * renders a report period as a single label, e.g. 'Jul 20 – Jul 24, 2026'. the year
 * is written once unless the period straddles two of them.
 * @param fromDate - period start, calendar date string
 * @param toDate - period end, calendar date string
 */
export function formatPeriod(fromDate, toDate) {
  const from = parseCalendarDate(fromDate);
  const to = parseCalendarDate(toDate);

  if (!from) return formatCalendarDate(toDate);
  if (!to) return formatCalendarDate(fromDate);

  if (from.getFullYear() === to.getFullYear()) {
    return `${dayjs(from).format('MMM D')} – ${dayjs(to).format(
      'MMM D, YYYY'
    )}`;
  }
  return `${formatCalendarDate(fromDate)} – ${formatCalendarDate(toDate)}`;
}

/**
 * the ISO 8601 week a period belongs to, taken from its first day
 * @param fromDate - period start, calendar date string
 */
export function formatWeekLabel(fromDate) {
  const date = parseCalendarDate(fromDate);
  if (!date) return '';
  return `Week ${dayjs(date).isoWeek()}`;
}

/**
 * formats the upload timestamp. unlike the period dates this is a real instant,
 * so it can be parsed directly.
 * @param isoTimestamp - ISO 8601 timestamp
 */
export function formatCreatedAt(isoTimestamp) {
  if (!isoTimestamp) return '';
  return dayjs(isoTimestamp).format('MMM D, YYYY');
}
